/**
 * Brand Configuration
 * Centralized configuration for brand identity and styling
 * All values are loaded from environment variables for easy customization
 */

const brandConfig = {
  // Brand Name Components
  name: process.env.REACT_APP_NAME || 'LotesPro',
  namePrefix: process.env.REACT_APP_NAME_PREFIX || 'Lotes',
  nameSuffix: process.env.REACT_APP_NAME_SUFFIX || 'Pro.com',
  domain: process.env.REACT_APP_DOMAIN || 'lotespro.com',

  // Brand Colors
  primaryColor: process.env.REACT_APP_BRAND_COLOR || '#E8751A',
  secondaryColor: process.env.REACT_APP_SECONDARY_COLOR || '#FFBF00',

  // Brand Messaging
  slogan: process.env.REACT_APP_BRAND_SLOGAN || 'Plataforma Inmobiliaria',

  // Service URLs
  dashboardUrl: process.env.REACT_APP_DASHBOARD_URL || 'https://dashboard.lotespro.com',
  projectDemoUrl: process.env.REACT_APP_PROJECT_DEMO || 'http://localhost:3001/proyectos/residencial-santa-clara',
  apiUrl: process.env.REACT_APP_API_URL || 'https://api.lotespro.com',

  // Contact & Support
  whatsappSupport: process.env.REACT_APP_WHATSAPP_SUPPORT || '+51949033237',
  emailContact: process.env.REACT_APP_EMAIL_CONTACT || 'info@cloud4geo.com',
  gaId: process.env.REACT_APP_GA_ID || '',

  // Helper methods
  getFullName: () => {
    return `${brandConfig.namePrefix}${brandConfig.nameSuffix.replace('.com', '')}.com`;
  },

  getPrimaryGradient: () => {
    return `linear-gradient(135deg, ${brandConfig.primaryColor} 0%, ${brandConfig.secondaryColor} 100%)`;
  },

  getLogoAlt: () => {
    return `${brandConfig.domain} Logo`;
  }
};

export default brandConfig;
